export interface SankeyLink {
  source: string
  target: string
  value: number
}

export interface SankeyNode {
  name: string
  category?: string
}

export interface InheritanceFlowData {
  nodes: SankeyNode[]
  links: SankeyLink[]
}

export interface ShareDistributionData {
  shareRanges: Array<{
    range: string
    count: number
    percentage: number
  }>
  byType: Array<{
    type: string
    count: number
  }>
  samples: Array<{
    text: string
    count: number
  }>
}

export interface TimelineData {
  period: string
  heritage: number
  donation: number
  partage: number
  totalValue: number
}

export interface InheritanceFlowChartLabels {
  flowAnalysis?: string
  flowAnalysisSubtext?: string
  transactions?: string
  shareDistribution?: string
  shareDistributionSubtext?: string
  inheritanceOverTime?: string
  inheritanceOverTimeSubtext?: string
  transactionCount?: string
  heritage?: string
  donation?: string
  partage?: string
  noData?: string
}

export const DEFAULT_INHERITANCE_FLOW_CHART_LABELS: InheritanceFlowChartLabels =
  {
    flowAnalysis: 'Inheritance Flow Analysis',
    flowAnalysisSubtext:
      'Wealth transfer from sellers to buyers through property types',
    transactions: 'transactions',
    shareDistribution: 'Share Distribution Analysis',
    shareDistributionSubtext: 'Ownership share patterns in transfers',
    inheritanceOverTime: 'Inheritance Transactions Over Time',
    inheritanceOverTimeSubtext: 'Quarterly trends by transaction type',
    transactionCount: 'Transaction Count',
    heritage: 'Heritage',
    donation: 'Donation',
    partage: 'Partage',
    noData: 'No inheritance data available',
  }

export interface InheritanceFlowChartProps {
  flowData?: InheritanceFlowData
  shareData?: ShareDistributionData
  timelineData?: TimelineData[]
  loading?: boolean
  error?: string | null
  height?: number
  labels?: Partial<InheritanceFlowChartLabels>
}
